export default __webpack_public_path__ + "static/media/rf.7c39c914.jpg";